import { render, staticRenderFns } from "./DashboardPayrollBreakup.vue?vue&type=template&id=ff066774"
import script from "./DashboardPayrollBreakup.vue?vue&type=script&lang=js"
export * from "./DashboardPayrollBreakup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports